import React, { Component } from 'react'
import Navbar from "../commons/Navbar";


export class Projectdetail extends Component {
  

  render() {
    return (
      <div className="projectDetail">
        <Navbar />

        <div className="projectHeader jumbotron">
          <div className="overlay" style={this.props.style}></div>
          <img src={this.props.image} alt="" />
          <div className="overlay-content">
            <h1 className="heading-1">{this.props.heading}</h1>
          </div>
        </div>

        <div className="container">
          <div className="content">
            <div className="description">
              {this.props.content}
              <ul>
                <li>
                  <h3 className="heading-3">Web Site</h3>
                
                  <a target="_blank" rel="noopener noreferrer"  href={this.props.website}>{this.props.website}
                  </a>
                </li>

                <li>
                  <h3 className="heading-3">Github</h3>
                  
                  <a target="_blank" rel="noopener noreferrer"  href={this.props.github}>
                  {this.props.github}
                  </a>
                  
                </li>
              </ul>
            </div>

            <div className="technologies">

              <h3 className="heading-3">Technologies Used in this Project</h3>

              <ul>{this.props.techs}</ul>
            </div>

            {
              this.props.updates.length > 0 ?
              <div className="recentUpdates">{this.props.updates}</div>
              : ""
            }

            {
              this.props.images.length > 0 ? 
              <div className="gallerylist">
                <h2 className="heading-2">Gallery</h2>
                <div className="images">{this.props.images}</div> 
              </div> :  ""
            }

            
          </div>
        </div>
      </div>
    );
  }
}

export default Projectdetail
